import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Paper,
  TableContainer,
  CircularProgress,
  Typography,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Snackbar,
  Alert,
  Tooltip,
  Chip,
  Divider, Box, Container, Stack
} from "@mui/material";
import YesNoField from "../formViews/YesNoField";
import ParticipantDetailsDialog from "./ParticipantDetailsDialog";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import EditNoteIcon from "@mui/icons-material/EditNote";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { messages } from "../config/messages";
import { USER_ACTIONS, isAllowedAction } from "../config/auth";
import { useNavigate } from "react-router-dom";

import {
  PARTICIPANT_FORM_SUBMITION,
  PARTICIPANT_APPROVAL_API,
  PARTICIPANT_WITHDRAW_API,
  PARTICIPANT_SUSPEND_API,
  PARTICIPANT_FORM_SCHEMA,
  PARTICIPANT_EVALUATE_STATUS_CHANGE_API,
  PARTICIPANT_UNSUSPEND_API,
  PARTICIPANT_REOPEN_API,
  PARTICIPANT_EXPORT_API,
  PARTICIPANT_EU_TAG_UPDATE,
  PARTICIPANT_LLMS4EU_UPDATE,
} from "../config/settings";
import {parseErrorData} from "../config/commonFunctions";

import { DataGrid } from '@mui/x-data-grid';
/* import {
  getTitleByField,
  getDescriptionByField,
} from "../config/commonFunctions"; */

const ParticipantList = () => {
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [approveData, setApproveData] = useState({});
  const [editEUTagData, setEditEUTagData] = useState({});
  const [editLLMs4euPartnerData, setEditLLMs4euPartnerData] = useState({});
  const [schemaAsObject, setSchemaAsObject] = useState({});
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [validatedEU, setValidatedEU] = useState(false);
  const [llms4euPartner, setLlms4euPartner] = useState(false);
  const [dialogRejectOpen, setDialogRejectOpen] = useState(false);
  const [dialogShowReason, setDialogShowReason] = useState(false);
  const [dialogSuspendOpen, setDialogSuspendOpen] = useState(false);
  const [dialogRequestSuspendOpen, setDialogRequestSuspendOpen] = useState(false);
  const [dialogRequestUnSuspendOpen, setDialogRequestUnSuspendOpen] = useState(false);
  const [dialogWithdrawOpen, setDialogWithdrawOpen] = useState(false);
  const [dialogRequestWithdrawOpen, setDialogRequestWithdrawOpen] = useState(false);
  const [suspendReinstateDialogOpen, setSuspendReinstateDialogOpen] = useState("");
  const [withdrawReinstateDialogOpen, setWithdrawReinstateDialogOpen] = useState("");
  const [dialogApproveOpen, setDialogApproveOpen] = useState(false);
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [suspendReason, setSuspendReason] = useState("");
  const [withdrawReason, setWithdrawReason] = useState("");
  const [suspendRequestReason, setSuspendRequestReason] = useState("");
  const [suspendDecision, setSuspendDecision] = useState("");
  const [unSuspendRequestReason, setUnSuspendRequestReason] = useState("");
  const [unSuspendDecision, setUnSuspendDecision] = useState("");
  const [withdrawRequestReason, setWithdrawRequestReason] = useState("");
  const [withdrawDecision, setWithdrawDecision] = useState("");
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [dialogEditEUTagOpen, setDialogEditEUTagOpen] = useState(false);
  const [dialogEditLLMs4euPartnerOpen, setDialogEditLLMs4euPartnerOpen] = useState(false);
  const [selectedParticipantObj, setSelectedParticipantObj] = useState(null);
  const [menuParticipant, setMenuParticipant] = useState(null);
  // Track form validation
  const [isFormValid, setIsFormValid] = useState(false);
  const language = "en";
  const open = Boolean(anchorEl);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const statusColors = {
    APPROVED: "success",
    REJECTED: "error",
    SUSPENDED: "warning",
    WITHDRAWN: "secondary",
    PENDING: "info"
  };
  //"default" "primary" "secondary" "error" "warning" "info" "success"

  const requestedColors = {
    REQUESTED_SUSPENSION: "warning",
    NO_REQUEST: "default",
    REQUESTED_WITHDRAWAL: "secondary",
    REQUESTED_UNDO_SUSPENSION: "warning",
  };

  const CcColors = {
    false: "success",
    true: "warning",
  };

  const fetchSchema = async () => {
    const url = PARTICIPANT_FORM_SCHEMA + language + "/";
    const response = await axios.get(url);
    setSchemaAsObject(response.data);
    // console.log("Fetched Schema:", response.data);
  };

  const fetchParticipants = async () => {
    try {
      const response = await axios.get(PARTICIPANT_FORM_SUBMITION);
      const sortedParticipants = response.data.sort((a, b) => {
        const nameA = a.name.find((n) => n.language === language)?.value || '';
        const nameB = b.name.find((n) => n.language === language)?.value || '';
        return nameA.localeCompare(nameB);
      });
      setParticipants(sortedParticipants);
      // console.log("Fetched Participants:", response.data);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParticipants();
    fetchSchema();
  }, []);

  const handleNameClick = (participant) => {
    setSelectedParticipantObj(participant); // Store the entire participant object
    setDetailsDialogOpen(true);
  };

  const handleDetailsDialogClose = () => {
    setDetailsDialogOpen(false);
  };

  const handleEdit = (participant) => {
    // console.log(participant, menuParticipant);
    navigate(`/participant-form/${participant.id}`); // , { state: { participant } }
  };

  const handleDocumentEdit = (participant) => {
    // console.log(participant, menuParticipant);
    navigate(`/participant-documents/${participant.id}`); // , { state: { participant } }
  };

  const handleClick = (event, participant) => {
    setAnchorEl(event.currentTarget);
    // console.log(participant);
    setMenuParticipant(participant.participant);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApprove = (participant, validatedEUValue, llms4euPartnerValue) => {
    setSelectedParticipant(participant);
    setValidatedEU(
      validatedEUValue === true
        ? true
        : validatedEUValue === false
        ? false
        : null
    );
    setLlms4euPartner(
      llms4euPartnerValue === true
        ? true
        : llms4euPartnerValue === false
        ? false
        : null
    );
    setDialogApproveOpen(true);
    setApproveData({
      participantID: participant,
      approved: true,
      validated_eu_controlled : validatedEU,
      llms4eu_partner: llms4euPartner,
    }); // Reset data
    handleClose();
  };

  const handleEditEUTag = (participant, validatedEUValue) => {
    setSelectedParticipant(participant);
    setValidatedEU(
      validatedEUValue === true
        ? true
        : validatedEUValue === false
        ? false
        : null
    );
    setDialogEditEUTagOpen(true);
    setEditEUTagData({
      participantID: participant,
      validated_eu_controlled : validatedEU
    }); // Reset data
    handleClose();
  };

  const handleDialogEditEUTagClose = () => {
    setDialogEditEUTagOpen(false);
  };

  const handleEditLLMs4euPartner = (participant, llms4euPartnerValue) => {
    setSelectedParticipant(participant);
    setLlms4euPartner(
      llms4euPartnerValue === true
        ? true
        : llms4euPartnerValue === false
        ? false
        : null
    );
    setDialogEditLLMs4euPartnerOpen(true);
    setEditLLMs4euPartnerData({
      participantID: participant,
      llms4eu_partner : llms4euPartner
    }); // Reset data
    handleClose();
  };

  const handleDialogEditLLMs4euPartnerClose = () => {
    setDialogEditLLMs4euPartnerOpen(false);
  };

  const handleDialogApproveClose = () => {
    setDialogApproveOpen(false);
  };

  const handleReject = (participant) => {
    setSelectedParticipant(participant);
    setDialogRejectOpen(true);
    handleClose();
  };

  const handleDialogRejectClose = () => {
    setDialogRejectOpen(false);
    setReason(""); // Clear the reason input
  };


  const handleShowReason = (participant) => {
    setSelectedParticipant(participant);
    setDialogShowReason(true);
    handleClose();
  };

  const handleShowReasonClose = () => {
    setDialogShowReason(false);
  };

  const handleSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogSuspendOpen(true);
    handleClose();
  };

  const handleDialogSuspendClose = () => {
    setDialogSuspendOpen(false);
    setSuspendReason(""); // Clear the reason input
  };

  const handleRequestSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestSuspendOpen(true);
    handleClose();
  };

  const handleRequestUnSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestUnSuspendOpen(true);
    handleClose();
  };

  const handleRequestWithdraw = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestWithdrawOpen(true);
    handleClose();
  };

  const handleDialogRequestSuspendClose = () => {
    setDialogRequestSuspendOpen(false);
    setSuspendRequestReason(""); // Clear the reason input
  };

  const handleDialogRequestUnSuspendClose = () => {
    setDialogRequestUnSuspendOpen(false);
    setUnSuspendRequestReason(""); // Clear the reason input
  };

  const handleDialogRequestWithdrawClose = () => {
    setDialogRequestWithdrawOpen(false);
    setWithdrawRequestReason(""); // Clear the reason input
  };

  const handleWithdraw = (participant) => {
    setSelectedParticipant(participant);
    setDialogWithdrawOpen(true);
    handleClose();
  };

  const handleDialogWithdrawClose = () => {
    setDialogWithdrawOpen(false);
    setWithdrawReason(""); // Clear the reason input
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDelete = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setDialogDeleteOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleDialogDeleteClose = () => {
    setDialogDeleteOpen(false);
  };

  const handleSuspendReinstateSubmitDialogOpen = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setSuspendReinstateDialogOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleSuspendReinstateSubmitDialogClose = () => {
    setSuspendReinstateDialogOpen(false);
  };

  const handleWithdrawReinstateSubmitDialogOpen = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setWithdrawReinstateDialogOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleWithdrawReinstateSubmitDialogClose = () => {
    setWithdrawReinstateDialogOpen(false);
  };

  const handleExport = async () => {
    try {
      const url = `${PARTICIPANT_EXPORT_API}?requested_ids=${rowSelectionModel.join(',')}`;
      const response = await axios.get(url, { responseType: 'blob' });
      if (response.data && response.data.size > 0) {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'participants.csv';
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1];
          }
        }
        const blobUrl = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

      } else {
        console.warn("No data received for export.");
      }
    } catch (err) {
      console.error("Error during export:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsExportSnackbarError;
    }
  };

  const handleSubmitApproval = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        approved: true,
        validated_eu_controlled: validatedEU,
        llms4eu_partner: llms4euPartner,
      };
      // console.log(payload);
      await axios.put(PARTICIPANT_APPROVAL_API, payload);
      setDialogApproveOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsApproveSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during approval:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsApproveSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleEditEUTagSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        validated_eu_controlled: validatedEU,
      };
      // console.log(payload);
      await axios.put(PARTICIPANT_EU_TAG_UPDATE, payload);
      setDialogEditEUTagOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.dialogEditEUTagSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during EU Tag update:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.dialogEditEUTagSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleEditLLMs4euPartnerSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        llms4eu_partner: llms4euPartner,
      };
      // console.log(payload);
      await axios.put(PARTICIPANT_LLMS4EU_UPDATE, payload);
      setDialogEditLLMs4euPartnerOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.dialogEditLLMs4euPartnerSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during LLMs4euPartner update:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.dialogEditLLMs4euPartnerSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitRejection = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        approved: false,
        reason: reason,
      };
      await axios.put(PARTICIPANT_APPROVAL_API, payload);
      setDialogRejectOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsRejectSnackabarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during rejection:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsRejectSnackabarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSuspendReinstateSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
      };
      await axios.put(PARTICIPANT_UNSUSPEND_API, payload);
      setSuspendReinstateDialogOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsReinstateSnackabarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during action:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsReinstateSnackabarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleWithdrawReinstateSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
      };
      await axios.put(PARTICIPANT_REOPEN_API, payload);
      setWithdrawReinstateDialogOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsReinstateSnackabarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during action:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsReinstateSnackabarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitSuspend = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: suspendReason,
      };

      await axios.put(PARTICIPANT_SUSPEND_API, payload);
      setDialogSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsSuspendSnackabarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsSuspendSnackabarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleRequestSuspendSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: suspendRequestReason,
        requested_status: "suspension",
        approved: suspendDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };

      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsEvaluateStatusChangeSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsEvaluateStatusChangeSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleRequestUnSuspendSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: unSuspendRequestReason,
        requested_status: "undo suspension",
        approved: unSuspendDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };

      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestUnSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsEvaluateStatusChangeSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsEvaluateStatusChangeSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleRequestWithdrawSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: withdrawRequestReason,
        requested_status: "withdrawal",
        approved: withdrawDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };
      // console.log(payload);
      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestWithdrawOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsEvaluateStatusChangeSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during termination:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsEvaluateStatusSentSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitWithdraw = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: withdrawReason,
      };
      await axios.put(PARTICIPANT_WITHDRAW_API, payload);
      setDialogWithdrawOpen(false);
      await fetchParticipants();
      setSnackbarMessage(messages.participantDetailsWithdrawSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during withdrawing:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsWithdrawSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  // Function to handle actual deletion request
  const confirmDelete = async () => {
    try {
      await axios.delete(
        `${PARTICIPANT_FORM_SUBMITION}${selectedParticipant.id}/`
      ); // must end with /
      setDialogDeleteOpen(false);
      await fetchParticipants(); // Refresh the participant list after deletion
      setSnackbarMessage(messages.participantDetailsDeleteSnackbarSuccess);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during deletion:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || messages.participantDetailsDeleteSnackbarError;
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const renderParticipantDates = (row) => {
    // console.log(row);
    const dateFields = [
      { label: "Created", value: row.created_at },
      { label: "Approved", value: row.approved_at },
      { label: "Updated", value: row.update_at },
      { label: "Rejected", value: row.rejected_at },
      { label: "Reopened", value: row.reopened_at },
      { label: "Suspended", value: row.suspended_at },
      { label: "Reinstated", value: row.reinstated_at },
      { label: "Terminated", value: row.withdrawn_at },
    ];
    return (
      <Box sx={{ whiteSpace: 'pre-line' }}>
        {dateFields
          .filter(field => field.value)
          .map(field => `${field.label}: ${field.value}`)
          .join('\n')}
      </Box>
    );
  };

  const renderConnectorStatus = (row) => {
    const status = row.deleted;
    return status ? <Chip label="deleted" size="small" /> : null;
  };

  if (loading) {
    return (
      <Paper style={{ padding: "20px", textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="h6">Loading participants...</Typography>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper
        style={{
          padding: "20px",
          textAlign: "center",
          backgroundColor: "rgba(255, 0, 0, 0.1)",
        }}
      >
        <Typography variant="h6" color="error">
          Error loading participants: {error.message}
        </Typography>
      </Paper>
    );
  }
  // console.log(participants);
  const columns = [
    { field: "id", headerName: "Participant ID", width: 120 },
    {
      field: "name",
      headerName: "Organisation Name",
      width: 230,
      valueGetter: (params) => {
        if (!Array.isArray(params) || params.length === 0) {
          return "Unnamed Participant";
        }
        const filteredNames = params
          .filter((nameObj) => nameObj.language === language)
          .map((nameObj) => nameObj.value);

        return filteredNames.length > 0 ? filteredNames.join(", ") : "Unnamed Participant";
      },
      renderCell: (params) => (
        <>
          <div style= {{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: 1.5,
            width: '100%',
          }}>
            {params.row.name.length > 0 ? (
              params.row.name
                .filter((nameObj) => nameObj.language === language)
                .map((nameObj, index) => (
                  <Typography
                    variant="body1"
                    key={index}
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => handleNameClick(params.row.participant)}
                  >
                    {nameObj.value}
                  </Typography>
                ))
            ) : (<Typography variant="body1">{messages.participantListUnmameParticipant}</Typography>)
            }
          </div>
          <div><Typography variant="caption" className="grey-font-light">{renderParticipantDates(params.row.management)}</Typography></div>
        </>),
    },
    {
      field: "opt_out_central_catalogue",
      headerName: "Visible in CC",
      width: 100,
      renderCell: (params) => (
          <Chip label={params.row.management.opt_out_central_catalogue === false ? "Yes": "No"} variant="outlined" color={CcColors[params.row.management.opt_out_central_catalogue] || "default"} />
      ),
    },
    {
      field: "eu_controlled_entity",
      headerName: "Organisation controlled by EU entities",
      width: 110,
      renderCell: (params) => (<>
        <Chip label={params.row.eu_controlled_entity === false ? "Yes" : "No"}/>
      </>
      ),
    },
    {
      field: "validated_eu_controlled",
      headerName: "Verified as EU-controlled",
      width: 110,
      renderCell: (params) => (<>
        <Chip label={params.row.management.validated_eu_controlled === false ? "Yes" : "No"}/>
      </>
      ),
    },
    {
      field: "llms4eu_partner",
      headerName: "LLMs4EU Partner",
      width: 100,
      renderCell: (params) => (<>
        <Chip label={params.row.management.llms4eu_partner === false ? "Yes" : "No"}/>
      </>
      ),
    },
    {
      field: "firstConnectorName",
      headerName: "Connectors",
      width: 200,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
          {params.row.connector && params.row.connector.length > 0 ? (
            params.row.connector.map((nameObj, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <Typography variant="body2">{nameObj.name}</Typography>
                {nameObj.deleted && (
                  <Chip label="deleted" size="small" color="warning" />
                )}
              </div>
            ))
          ) : (
            <Typography variant="body1">{messages.participantListEmptyConnectors}</Typography>
          )}
        </div>
      ),
    },
    {
      field: "request_status",
      headerName: "Request status",
      width: 150,
      renderCell: (params) => (
          <Chip label={params.row.management.request_status} variant="outlined" color={requestedColors[params.row.management.request_status] || "default"} />
      ),
    },
    {
      field: "approval_status",
      headerName: "Status",
      width: 150,

      // This is what the DataGrid uses for filtering, sorting, and export
      valueGetter: (value, row) => {
        const status = row.management.approval_status;
        if (status === "WITHDRAWN") return "TERMINATED";
        if (status === "REQUESTED_WITHDRAWAL") return "REQUESTED_TERMINATION";
        return status;
      },

      renderCell: (params) => (
        <Tooltip
          title={params.row.management.approval_status === "REJECTED" ? params.row.management.reason : ""}
          placement="top"
          arrow
        >
          <Chip
            label={params.value} // params.value now reflects the mapped label
            color={statusColors[params.row.management.approval_status] || "default"}
          />
        </Tooltip>
      ),
    },
    {
      field: "management",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      valueGetter: (params) => {
        // console.log(params);
        return params.approval_status || "Unknown Status";
      },
      renderCell: (params) => {
        // console.log("Approval Status:", params.row);
        return isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) ? (
          <>
            <Button id="basic-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={(e) => handleClick(e, params.row)}>
              {messages.actions}
            </Button>
            <Menu id="basic-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary"}}>
                {messages.participantListManage}
              </Typography>
              <MenuItem onClick={() => handleApprove(menuParticipant, menuParticipant?.management?.validated_eu_controlled, menuParticipant?.management?.llms4eu_partner)} disabled={["APPROVED", "REJECTED", "SUSPENDED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <TaskAltIcon fontSize="small" sx={{ pr: 2 }} /> Approve
              </MenuItem>
              <MenuItem onClick={() => handleEditEUTag(menuParticipant, menuParticipant?.management?.validated_eu_controlled)} disabled={["PENDING", "REJECTED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <TaskAltIcon fontSize="small" sx={{ pr: 2 }} /> Edit EU control status
              </MenuItem>
              <MenuItem onClick={() => handleEditLLMs4euPartner(menuParticipant, menuParticipant?.management?.llms4eu_partner)} disabled={["PENDING", "REJECTED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <TaskAltIcon fontSize="small" sx={{ pr: 2 }} /> Edit LLMs4euPartner status
              </MenuItem>
              <MenuItem onClick={() => handleReject(menuParticipant)} disabled={["APPROVED", "REJECTED", "SUSPENDED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <HighlightOffIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.participantListRejectAction}
              </MenuItem>
              {["APPROVED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListSuspendAction}
                </MenuItem>
              }
              {["REQUESTED_SUSPENSION"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListAcceptSuspensionAction}
                </MenuItem>
              }
              {["SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleSuspendReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListBackToApprovedAction}
                </MenuItem>
              }
              {// ["SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["REQUESTED_UNDO_SUSPENSION"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestUnSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListAcceptUnsuspensionAction}
                </MenuItem>
              }
              {/* ["WITHDRAWN", "REJECTED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdrawReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Reinstate to PENDING
                </MenuItem>
              } */}

              {["REJECTED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdrawReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListBackToPendingAction}
                </MenuItem>}

              {["APPROVED", "SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdraw(menuParticipant)}>
                  <RemoveRoadIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListTerminateAction}
                </MenuItem>
              }

              {["REQUESTED_WITHDRAWAL"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestWithdraw(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  {messages.participantListAcceptTerminateAction}
                </MenuItem>
              }

              <Divider sx={{ my: 0.5 }} />
              <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary" }}>
                {messages.modify}
              </Typography>
              <MenuItem onClick={() => handleDelete(menuParticipant)} disabled={["APPROVED"].includes(menuParticipant?.management?.approval_status)}>
                <DeleteForeverIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.delete}
              </MenuItem>

              <MenuItem onClick={() => handleEdit(menuParticipant)} disabled={["WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <AppRegistrationIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.participantDetailsAdminEditButton}
              </MenuItem>

              <MenuItem onClick={() => handleDocumentEdit(menuParticipant)} disabled={["WITHDRAWN", "REJECTED"].includes(menuParticipant?.management?.approval_status)}>
                <EditNoteIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.participantDetailsAdminEditDocumentsButton}
              </MenuItem>

              <Divider sx={{ my: 0.5}}/>
              <MenuItem onClick={() => handleShowReason(menuParticipant)}
                disabled={["APPROVED", "PENDING"].includes(menuParticipant?.management?.approval_status)}>
                <HighlightOffIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.participantListShowReasonAction}
              </MenuItem>
            </Menu>
          </>
        ) : (isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY) && (
          <>
            <Button id="basic-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={(e) => handleClick(e, params.row)}>
              {messages.actions}
            </Button>
            <Menu id="basic-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary" }}>
                {messages.participantListManage}
              </Typography>
              <MenuItem onClick={() => handleDocumentEdit(menuParticipant)} disabled={["WITHDRAWN", "REJECTED"].includes(menuParticipant?.management?.approval_status)}>
                <EditNoteIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                {messages.participantDetailsAdminEditDocumentsButton}
              </MenuItem></Menu>
          </>)
        )
      },
      },
  ];

  const rows = participants.map((participant) => ({
    id: participant.id,
    participant: participant,
    name: participant.name,
    created_at: participant.management.created_at,
    approved_at: participant.management.approved_at,
    rejected_at: participant.management.rejected_at,
    reopened_at: participant.management.reopened_at,
    suspended_at: participant.management.suspended_at,
    reinstated_at: participant.management.reinstated_at,
    withdrawn_at: participant.management.withdrawn_at,
    connector: participant.connector,
    // <-- precompute first connector name for sorting/filtering
    firstConnectorName:
      Array.isArray(participant.connector) && participant.connector.length > 0
        ? (participant.connector.find(conn => conn.deleted === false)?.name || messages.participantListEmptyConnectors)
        : messages.participantListEmptyConnectors,
    approval_status: participant.management.approval_status,
    request_status: participant.management.request_status,
    opt_out_central_catalogue: participant.management.opt_out_central_catalogue,
    management: participant.management,
  }));

    return (
        <Container maxWidth= "xl">

        <TableContainer
          component={Paper}
          style={{ padding: "20px", marginTop: "1em" }}
        > <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <Typography variant="h3" gutterBottom sx={{ mb: 2, mt: 5, color: "#213270" }}>
                {messages.participnatListPageTitle}
              </Typography>
              <Typography variant="h5" gutterBottom sx={{ mb: 2, mt: 2 }}>
                {messages.registryHomeAdminCardSubTitle}
              </Typography>
            </div>
            <div>
              <Button variant="contained" onClick={handleExport} style={{ marginTop: '16px' }}>
                {messages.participantListExportButton}
              </Button>
            </div>
          </div>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowHeight={() => 100}
                    pageSize={5}
                    checkboxSelection
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                      setRowSelectionModel(newRowSelectionModel);
                    }}
                    rowSelectionModel={rowSelectionModel}
                    disableRowSelectionOnClick
                    sx={{
                        "& .MuiDataGrid-cell": {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        },
                    }}
                />
                <Button variant="contained" onClick={handleExport} style={{ marginTop: '16px' }}>
                  {messages.participantListExportButton}
                </Button>
                {/* Reject Dialog */}
                <Dialog
                    open={dialogRejectOpen}
                    onClose={handleDialogRejectClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>{messages.dialogTitleReject}</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">{messages.dialogRejectAsk} "{selectedParticipant?.name[0]?.value}? "</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label={messages.dialogTextFieldRejectReason}
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogRejectClose} color="primary" variant="outlined">
                            {messages.cancel}
                        </Button>
                        <Tooltip title={reason === "" ? messages.fillAllMessage : ""} placement="top" arrow >
                            <div>
                                <Button
                                    onClick={handleSubmitRejection}
                                    color="primary"
                                    variant="outlined"
                                    disabled={reason === ""}
                                >
                                    {messages.dialogRejectSubmit}
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>

                {/* suspend admin Dialog */}
                <Dialog
                    open={dialogSuspendOpen}
                    onClose={handleDialogSuspendClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>{messages.dialogTitleSuspend}</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">{messages.dialogSuspendAsk} "{selectedParticipant?.name[0]?.value}" ?</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label={messages.dialogTextFieldSuspendReason}
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={suspendReason}
                                onChange={(e) => setSuspendReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogSuspendClose} color="primary" variant="outlined">
                            {messages.cancel}
                        </Button>
                        <Tooltip title={suspendReason === "" ? messages.fillAllMessage : ""} placement="top" arrow>
                            <div><Button
                                onClick={handleSubmitSuspend}
                                color="primary"
                                variant="outlined"
                                disabled={suspendReason === ""}
                            >
                                {messages.dialogSuspendSubmit}
                            </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
                {/* suspend On request Dialog */}
                <Dialog
                  open={dialogRequestSuspendOpen}
                  onClose={handleDialogRequestSuspendClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleRequestSuspend}</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      {messages.dialogRequestSuspendAsk}
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={suspendDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setSuspendDecision("true")}
                      >
                        {messages.dialogSuspendAcceptSubmit}
                      </Button>
                      <Button
                        variant={suspendDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setSuspendDecision("false")}
                      >
                        {messages.dialogSuspendDeclineSubmit}
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a suspendDecision is made) */}
                    {suspendDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${suspendDecision === "true" ? "accepting" : "declining"} suspension`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={suspendRequestReason}
                          onChange={(e) => setSuspendRequestReason(e.target.value)}
                          // error={!suspendRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!suspendRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                        <Button onClick={handleDialogRequestSuspendClose} color="primary" variant="outlined">
                          {messages.cancel}
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleRequestSuspendSubmit}
                          disabled={!suspendDecision || !suspendRequestReason} // Disable if no suspendDecision or no reason
                        >
                          {messages.confirm}
                        </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* suspend On request Dialog */}
                <Dialog
                  open={dialogRequestUnSuspendOpen}
                  onClose={handleDialogRequestUnSuspendClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleRequestUnSuspend}</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      {messages.dialogRequestUnSuspendAsk}
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={unSuspendDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setUnSuspendDecision("true")}
                      >
                        {messages.dialogUnSuspendAcceptSubmit}
                      </Button>
                      <Button
                        variant={unSuspendDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setUnSuspendDecision("false")}
                      >
                        {messages.dialogUnSuspendDeclineSubmit}
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a unSuspendDecision is made) */}
                    {unSuspendDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${unSuspendDecision === "true" ? "accepting" : "declining"} unsuspension`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={unSuspendRequestReason}
                          onChange={(e) => setUnSuspendRequestReason(e.target.value)}
                          // error={!suspendRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!unSuspendRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                        <Button onClick={handleDialogRequestUnSuspendClose} color="primary" variant="outlined">
                          {messages.cancel}
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleRequestUnSuspendSubmit}
                          disabled={!unSuspendDecision || !unSuspendRequestReason} // Disable if no suspendDecision or no reason
                        >
                          {messages.confirm}
                        </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* withdraw Dialog */}
                <Dialog
                    open={dialogWithdrawOpen}
                    onClose={handleDialogWithdrawClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>{messages.dialogTitleTerminate}</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">{messages.dialogTerminateAsk} "{selectedParticipant?.name[0]?.value}" ?</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label={messages.dialogTextFielTerminateReason}
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={withdrawReason}
                                onChange={(e) => setWithdrawReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogWithdrawClose} color="primary" variant="outlined">
                            {messages.cancel}
                        </Button>
                        <Tooltip title={withdrawReason === "" ? messages.fillAllMessage : ""} placement="top" arrow >
                            <div>
                                <Button
                                    onClick={handleSubmitWithdraw}
                                    color="primary"
                                    variant="outlined"
                                    disabled={withdrawReason === ""}
                                >
                                    {messages.dialogTerminateSubmit}
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
                {/* withdraw On request Dialog */}
                <Dialog
                  open={dialogRequestWithdrawOpen}
                  onClose={handleDialogRequestWithdrawClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleRequestTerminate}</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      {messages.dialogRequestTerminateAsk}
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={withdrawDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setWithdrawDecision("true")}
                      >
                       {messages.dialogTerminateAcceptSubmit}
                      </Button>
                      <Button
                        variant={withdrawDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setWithdrawDecision("false")}
                      >
                        {messages.dialogTerminateDeclineSubmit}
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a withdrawDecision is made) */}
                    {withdrawDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${withdrawDecision === "true" ? "accepting" : "declining"} withdrawal`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={withdrawRequestReason}
                          onChange={(e) => setWithdrawRequestReason(e.target.value)}
                          // error={!withdrawRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!withdrawRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                      <Button onClick={handleDialogRequestWithdrawClose} color="primary" variant="outlined">
                        {messages.cancel}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleRequestWithdrawSubmit}
                        disabled={!withdrawDecision || !withdrawRequestReason} // Disable if no withdrawDecision or no reason
                      >
                        {messages.confirm}
                      </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* Approval Dialog */}
                <Dialog
                  open={dialogApproveOpen}
                  onClose={handleDialogApproveClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleApprove}</Typography></DialogTitle>
                <DialogContent>
              <Stack spacing={2}>
                <Typography variant="body1">{messages.eucontroledApprovalFormTitle}</Typography>
                <YesNoField
                  label={messages.EUControlledValidatedLabel}
                  helperText={messages.EUControlledValidatedhelperText}
                  value={validatedEU}
                  onChange={(value) => setValidatedEU(value)}
                  required={true}
                  yesLabel={messages.yesLabelEUControledApprovalForm}
                  noLabel={messages.noLabelEUControledApprovalForm}
                />

                <YesNoField
                  label={messages.llmsPartnerApprovalFormLabel}
                  helperText={messages.llmsPartnerApprovalhelperText}
                  value={llms4euPartner}
                  onChange={(value) => setLlms4euPartner(value)}
                  required={true}
                  yesLabel={messages.yesLabelParticipantForm}
                  noLabel={messages.noLabelParticipantForm}
                />

              <div stle={{ padding: 2 }}>
                <Typography variant="body1">{messages.dialogApproveAsk} "{selectedParticipant?.name[0]?.value}"" ?</Typography>
              </div>
              </Stack>
                </DialogContent>
                  <DialogActions>
                    <Button onClick={handleDialogApproveClose} color="primary" variant="outlined">{messages.cancel}</Button>
                    <Button onClick={handleSubmitApproval} color="primary" variant="outlined">{messages.dialogApproveSubmit}</Button>
                  </DialogActions>
                </Dialog>
                {/* Reinstate suspended Dialog */}
                <Dialog
                  open={suspendReinstateDialogOpen}
                  onClose={handleSuspendReinstateSubmitDialogClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleReinstate}</Typography></DialogTitle>
                  <DialogContent>
                    <div stle={{ padding: 2 }}>
                      <Typography variant="body1">{messages.dialogReinstateAsk} "{selectedParticipant?.name[0]?.value}"" ?</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleSuspendReinstateSubmitDialogClose} color="primary" variant="outlined">{messages.cancel}</Button>
                    <Button onClick={handleSuspendReinstateSubmit} color="primary" variant="outlined">{messages.submit}</Button>
                  </DialogActions>
                </Dialog>

                {/* Reinstate withdraw Dialog */}
                <Dialog
                  open={withdrawReinstateDialogOpen}
                  onClose={handleWithdrawReinstateSubmitDialogClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogTitleReinstateBack}</Typography></DialogTitle>
                  <DialogContent>
                    <div stle={{ padding: 2 }}>
                      <Typography variant="body1">{messages.dialogReinstateBackAsk} "{selectedParticipant?.name[0]?.value}"" ?</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleWithdrawReinstateSubmitDialogClose} color="primary" variant="outlined">{messages.cancel}</Button>
                    <Button onClick={handleWithdrawReinstateSubmit} color="primary" variant="outlined">{messages.submit}</Button>
                  </DialogActions>
                </Dialog>

                {/* Participant Details Dialog */}
                <ParticipantDetailsDialog
                    open={detailsDialogOpen}
                    onClose={handleDetailsDialogClose}
                    participant={selectedParticipantObj}
                    onEdit={handleEdit}
                    mappings={schemaAsObject.$defs}
                    schemaAsObject={schemaAsObject}
                />

                {/* Delete confirmation dialog */}
                <Dialog open={dialogDeleteOpen} onClose={handleDialogDeleteClose}>
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>{messages.dialogTitleDelete}</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">{messages.dialogDeleteAsk} "{selectedParticipant?.name[0]?.value}" ?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogDeleteClose} variant="outlined">{messages.cancel}</Button>
                        <Button onClick={confirmDelete} color="error" variant="outlined">{messages.delete}</Button>
                    </DialogActions>
                </Dialog>

                {/* Show reason Dialog */}
                <Dialog
                  open={dialogShowReason}
                  onClose={handleShowReasonClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogShowReasonTitle}</Typography></DialogTitle>
                  <DialogContent>
                    <div style={{ paddingTop: "1em" }}>
                      <Typography variant="body1">{selectedParticipant?.management?.reason}</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleShowReasonClose} variant="outlined">{messages.close}</Button>
                  </DialogActions>
                </Dialog>

                {/* Edit EU control status Dialog */}
                <Dialog
                  open={dialogEditEUTagOpen}
                  onClose={handleDialogEditEUTagClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogEditEUTagTitle}</Typography></DialogTitle>
                <DialogContent>
              <Stack spacing={2}>
                <Typography variant="body1">{messages.eucontroledEditFormTitle}</Typography>
                <YesNoField
                  label={messages.EUControlledValidatedLabel}
                  helperText={messages.EUControlledValidatedhelperText}
                  value={validatedEU}
                  onChange={(value) => setValidatedEU(value)}
                  required={true}
                  yesLabel={messages.yesLabelEUControledApprovalForm}
                  noLabel={messages.noLabelEUControledApprovalForm}
                />

              <div stle={{ padding: 2 }}>
                <Typography variant="body1">{messages.dialogEditEUTagAsk} "{selectedParticipant?.name[0]?.value}"" ?</Typography>
              </div>
              </Stack>
                </DialogContent>
                  <DialogActions>
                    <Button onClick={handleDialogEditEUTagClose} color="primary" variant="outlined">{messages.cancel}</Button>
                    <Button onClick={handleEditEUTagSubmit} color="primary" variant="outlined">{messages.dialogEditEUTagSubmit}</Button>
                  </DialogActions>
                </Dialog>

            {/* Edit LLMs4euPartner status Dialog */}
            <Dialog
                  open={dialogEditLLMs4euPartnerOpen}
                  onClose={handleDialogEditLLMs4euPartnerClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.dialogEditLLMs4euPartnerTitle}</Typography></DialogTitle>
                <DialogContent>
              <Stack spacing={2}>
                <Typography variant="body1">{messages.LLMs4euPartnerEditFormTitle}</Typography>
                <YesNoField
                  label={messages.llmsPartnerApprovalFormLabel}
                  helperText={messages.llmsPartnerApprovalhelperText}
                  value={llms4euPartner}
                  onChange={(value) => setLlms4euPartner(value)}
                  required={true}
                  yesLabel={messages.yesLabelParticipantForm}
                  noLabel={messages.noLabelParticipantForm}
                />

              <div stle={{ padding: 2 }}>
                <Typography variant="body1">{messages.dialogEditLLMs4euPartnerAsk} "{selectedParticipant?.name[0]?.value}"" ?</Typography>
              </div>
              </Stack>
                </DialogContent>
                  <DialogActions>
                    <Button onClick={handleDialogEditLLMs4euPartnerClose} color="primary" variant="outlined">{messages.cancel}</Button>
                    <Button onClick={handleEditLLMs4euPartnerSubmit} color="primary" variant="outlined">{messages.dialogEditLLMs4euPartnerSubmit}</Button>
                  </DialogActions>
                </Dialog>

            </TableContainer>

            {/* Snackbar Component */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ParticipantList;
